import type { RichTextItem } from '@/types/ads';

export const stickers: Record<string, { emoji: string; motion: string }> = {
  party: { emoji: '🎉', motion: 'rich-wiggle' },
  gift: { emoji: '🎁', motion: 'rich-bounce' },
  fire: { emoji: '🔥', motion: 'rich-pulse' },
  star: { emoji: '⭐', motion: 'rich-pulse' },
  heart: { emoji: '❤️', motion: 'rich-pulse' },
  arrow: { emoji: '👉', motion: 'rich-bounce' },
};
export const messageFallback = (items: RichTextItem[]) => items.map(item =>
  item.kind === 'IMAGE' ? item.alt ?? '' : item.kind === 'STICKER' ? stickers[item.sticker ?? '']?.emoji ?? '' : item.text ?? ''
).join(' ');

